<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <base-button
            @click="seeAllToggle"
            type="primary"
            size="sm"
            v-show="total > 15"
            >{{ seeAll ? "Pagniate" : "See all" }}</base-button
          >
          <base-button type="success" size="sm" @click="addAyahClick">
            <div class="d-flex justify-content-center align-items-center">
              <span class="" title="Click to add Verse">Add Ayah</span>
              <span class="ni ni-fat-add" style="font-size: 20px"></span></div
          ></base-button>
          <base-button type="primary" size="sm" @click="$router.go(-1)">
            <div class="d-flex align-items-center w-100">
              <span class="">Back</span> &#160;<span
                class="ni ni-curved-next"
                style="margin-bottom: 2px; margin-left: 2px"
              ></span>
            </div>
          </base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush verses-table"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        dir="rtl"
        :data="ayahs"
      >
        <template slot="columns">
          <th class="text-center">.No</th>
          <th class="text-center">.Verse No</th>
          <th class="text-right">Arabic Verse</th>
          <th class="text-center">Created At</th>
          <th class="text-center">Actions</th>
          <!-- <th>Completion</th> -->
        </template>

        <template slot-scope="{ row }">
          <th class="text-center">{{ countIndex(row) }}</th>
          <th class="text-center">{{ row.ayahNum }}</th>
          <th
            class="giveMeEllipsis text-right"
            style="max-width: 400px; font-size: 24px"
            :class="$store.getters.arabicFontStyle"
          >
            {{ row.fullAyah }}
          </th>
          <td class="text-center">
            <span>{{ row.createdAt | moment("MMM DD, YYYY h:m A") }}</span>
          </td>
          <td class="budget text-center">
            <span
              @click="editAyahClick(row)"
              style="margin-left: 10px"
              title="Click to edit verse"
              class="cursor_pointer"
            >
              <base-button type="default" size="sm">
                Edit <i class="fa fa-edit"></i>
              </base-button>
            </span>
            <span
              @click="deleteAyahClick(row)"
              style="margin-left: 10px"
              title="Click to delete verse"
              class="cursor_pointer"
            >
              <base-button type="warning" size="sm">
                Delete <i class="fa fa-times"></i>
              </base-button>
            </span>
          </td>
        </template>
      </base-table>
    </div>

    <div
      v-if="!total"
      class="no_record text-gray d-flex justify-content-center py-4"
      style="font-size: 14px"
    >
      No Record Found
    </div>

    <div
      v-if="ayahs && ayahs.length"
      class="card-footer"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <base-pagination
        align="end"
        :total="total"
        :perPage="perPage"
        :pageCount="pageCount"
        :value="page"
        @input="changePage"
      ></base-pagination>
    </div>

    <modal
      :show.sync="updateAyahModal"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <span
        class="close_update_form cursor_pointer"
        @click="updateAyahModal = false"
        >&#10006;</span
      >
      <update-ayah
        :model="ayahToUpdate"
        @refresh="refresh"
        @close="updateAyahModal = false"
      ></update-ayah>
    </modal>
  </div>
</template>
<script>
import UpdateAyah from "../UpdateAyah.vue";
import moment from "moment";

import * as api from "@/apiList";
export default {
  name: "surahs-table",
  components: {
    UpdateAyah,
  },
  props: {
    type: String,
    ayahs: Array,
    title: String,
    surahId: {
      default: "",
    },
    page: Number,
    perPage: Number,
    total: Number,
    seeAll: Boolean,
  },
  data() {
    return {
      languages: JSON.parse(localStorage.getItem("languages")),
      updateAyahModal: false,
      indexOfUpdatingAyah: -1,
      ayahToUpdate: {},
    };
  },
  methods: {
    async deleteAyahClick(ayah) {
      this.$confirm({
        title: "Confirmations!",
        message: `Are you sure to delete this ayah?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            const data = await api.deleteAyah(ayah._id);
            if (!data.response) {
              this.ayahs.splice(this.ayahs.indexOf(ayah), 1);
              this.$toast("Verse Deleted Successfully.", {
                position: "top-right",
                timeout: 5000,
                type: "success",
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                icon: true,
                rtl: false,
              });
            } else {
              this.$toast(`${data.response.data.message}`, {
                position: "top-right",
                timeout: 5000,
                type: "error",
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                icon: true,
                rtl: false,
              });
            }
          }
        },
      });
    },
    async editAyahClick(ayah) {
      this.indexOfUpdatingAyah = this.ayahs.indexOf(ayah);
      this.ayahToUpdate = { ...ayah };
      await this.setTranslationFields();
      this.updateAyahModal = true;
    },
    addAyahClick() {
      JSON.stringify(
        localStorage.setItem("add-ayah-for-surah-id", this.surahId)
      );
      this.$router.push({ path: "/add/ayah" });
    },
    refresh(value) {
      this.ayahs[this.indexOfUpdatingAyah] = value;
      this.updateAyahModal = false;
    },

    async setTranslationFields() {
      let czechLangObj = null;
      let { ayahTranslations } = this.ayahToUpdate;
      let finalAyahTrans = [];
      this.languages.forEach((elem) => {
        let language = {
          translation: "",
          translationId: elem._id,
          langName: elem.name,
        };
        ayahTranslations.forEach((el) => {
          if (el.translationId == elem._id) {
            language = {
              translation: el.translation,
              translationId: elem._id,
              langName: elem.name,
            };
          }
        });
        if (elem.name == "Arabština") {
        } else if (elem.name == "Čeština - Hrbek" || elem.name == "hrbek") {
          czechLangObj = language;
        } else {
          finalAyahTrans.push(language);
        }
      });
      if (czechLangObj) {
        finalAyahTrans.unshift(czechLangObj);
      }
      this.ayahToUpdate.ayahTranslations = finalAyahTrans;
    },

    countIndex(item) {
      let index = this.ayahs.indexOf(item) + 1;
      let page = this.page - 1;
      if (page > 0) {
        if (index == 10) {
          page = page + 1;
          index = 0;
          return page.toString() + index.toString();
        } else {
          return page.toString() + index.toString();
        }
      } else {
        return index.toString();
      }
    },
    changePage(value) {
      this.$emit("pageChange", value);
    },
    seeAllToggle() {
      this.$emit("seeAllToggle");
    },
  },
  computed: {
    pageCount() {
      let pageCount = this.total / this.perPage;
      if (pageCount > 0) {
        return Math.ceil(pageCount);
      } else {
        return 0;
      }
    },
  },
  mounted() {},
};
</script>
<style>
.cursor_pointer {
  cursor: pointer;
}
.close_update_form {
  position: absolute;
  z-index: 999;
  top: 10px;
  right: 12px;
  font-size: 12px;
}
.add__user_cross {
  position: absolute;
  right: 0 !important;
  top: -3px;
  border: 1px solid #f7fafc;
  background-color: #f7fafc;
  padding: 10px 15px;
  z-index: 9;
  border-radius: 100px;
  color: purple;
}
span.text-danger {
  font-size: 12px !important;
}
.input-danger {
  border: 1px solid red !important;
  border-radius: 7px;
}
.add__surah__form form {
  background: #f7fafc;
  padding: 10px 20px;
  border-radius: 0.375rem;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}
.surah__form__label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}
.surah__form__label.langNameLabel + div {
  margin-bottom: 0px;
}
.giveMeEllipsis {
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
}
.verses-table tbody tr:hover {
  outline: 2px solid #e0ffffc4 !important;
  background: #e0ffffc4;
}
</style>
